// utils/srtParser.js
/**
 * 解析SRT字幕文件
 * @param {string} srtContent - SRT文件内容
 * @returns {Array} 字幕数组
 */
export function parseSRT(srtContent) {
    if (!srtContent) return []

    const subtitles = []
    const blocks = srtContent.trim().split(/\n\s*\n/)

    blocks.forEach(block => {
        const lines = block.split('\n').filter(line => line.trim())

        if (lines.length >= 3) {
            const index = parseInt(lines[0].trim())

            // 解析时间轴：00:00:01,234 --> 00:00:04,567
            const timeMatch = lines[1].match(
                /(\d{2}):(\d{2}):(\d{2})[,.](\d{3})\s*-->\s*(\d{2}):(\d{2}):(\d{2})[,.](\d{3})/
            )

            if (timeMatch) {
                const startTime = parseSRTTime(timeMatch[1], timeMatch[2], timeMatch[3], timeMatch[4])
                const endTime = parseSRTTime(timeMatch[5], timeMatch[6], timeMatch[7], timeMatch[8])

                // 合并多行文本
                const text = lines.slice(2).join('\n')
                    .replace(/<[^>]+>/g, '') // 移除HTML标签（可选）
                    .trim()

                subtitles.push({
                    index,
                    start: startTime,
                    end: endTime,
                    text,
                    rawText: lines.slice(2).join('\n')
                })
            }
        }
    })

    return subtitles.sort((a, b) => a.start - b.start)
}

/**
 * 将SRT时间转换为秒
 */
function parseSRTTime(hours, minutes, seconds, milliseconds) {
    return (
        parseInt(hours) * 3600 +
        parseInt(minutes) * 60 +
        parseInt(seconds) +
        parseInt(milliseconds) / 1000
    )
}

/**
 * 将秒转换为SRT时间格式
 */
export function secondsToSRTTime(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = Math.floor(totalSeconds % 60)
    const milliseconds = Math.round((totalSeconds % 1) * 1000)

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')},${milliseconds.toString().padStart(3, '0')}`
}

// 绑定输入框的时间字符串
// const timeString = ref('00:00:50,064 --> 00:00:52,752')
// // 存储解析结果
// const parsedResult = ref(null)
export const timeToMilliseconds = (timeStr) => {
    // 复制上面的 timeToMilliseconds 函数逻辑
    if (!timeStr) return 0
    const normalizedStr = timeStr.replace(',', '.')
    const [hms, ms = '0'] = normalizedStr.split('.')
    const [hours = 0, minutes = 0, seconds = 0] = hms.split(':').map(Number)
    const msFixed = ms.padEnd(3, '0').slice(0, 3)
    return hours * 3600000 + minutes * 60000 + seconds * 1000 + Number(msFixed)
}
/**
 * 核心解析函数：拆分时间字符串为startTime和endTime
 * @param {string} str - 待解析的时间字符串（如 00:00:50,064 --> 00:00:52,752）
 * @returns {object} { startTime, endTime }
 */
    // 格式化时间
export const formatTime = (seconds) => {
        if (isNaN(seconds)) return '00:00'

        const mins = Math.floor(seconds / 60)
        const secs = Math.floor(seconds % 60)
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    };
export const parseTimeString = (str) => {
    if (!str) return {};

    // 第一步：按 --> 分割字符串（注意前后空格）
    let [startStr, endStr] = str.split(' --> ');

    if (!startStr || !endStr) {
        // alert('时间格式错误，请检查！')
        return {};
    }
    startStr = startStr.trim();
    endStr = endStr.trim();

    let startTimeMs = timeToMilliseconds(startStr);
    let endTimeMs = timeToMilliseconds(endStr);
    let startTimeS = startTimeMs / 1000;
    let endTimeS = endTimeMs / 1000;
    // 返回解析后的结果（保留原始格式，也可按需处理毫秒）
    return {
        startTime: formatTime(startTimeS), // 开始时间：00:00:50,064
        endTime: formatTime(endTimeS),      // 结束时间：00:00:52,752,
        startTimeMs,
        endTimeMs,
        startTimeS,
        endTimeS,


    }
};